// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"467":"81f1b1b5","787":"25277da6"}[chunkId] + ".chunk.js";
};